module.exports = __webpack_public_path__ + "static/media/powerGeneration.25bf0873.jpg";